export default __webpack_public_path__ + "static/media/feat-lock.098a1bd6.svg";